export default [
	{
		"label": "Andorra",
		"code": "AD"
	},
	{
		"label": "Förenade Arabemiraten",
		"code": "AE"
	},
	{
		"label": "Afghanistan",
		"code": "AF"
	},
	{
		"label": "Antigua och Barbuda",
		"code": "AG"
	},
	{
		"label": "Anguilla",
		"code": "AI"
	},
	{
		"label": "Albanien",
		"code": "AL"
	},
	{
		"label": "Armenien",
		"code": "AM"
	},
	{
		"label": "Nederländska Antillerna",
		"code": "AN"
	},
	{
		"label": "Angola",
		"code": "AO"
	},
	{
		"label": "Antarktis",
		"code": "AQ"
	},
	{
		"label": "Argentina",
		"code": "AR"
	},
	{
		"label": "Amerikanska Samoa",
		"code": "AS"
	},
	{
		"label": "Österrike",
		"code": "AT"
	},
	{
		"label": "Australien",
		"code": "AU"
	},
	{
		"label": "Aruba",
		"code": "AW"
	},
	{
		"label": "Åland",
		"code": "AX"
	},
	{
		"label": "Azerbajdzjan",
		"code": "AZ"
	},
	{
		"label": "Bosnien och Hercegovina",
		"code": "BA"
	},
	{
		"label": "Barbados",
		"code": "BB"
	},
	{
		"label": "Bangladesh",
		"code": "BD"
	},
	{
		"label": "Belgien",
		"code": "BE"
	},
	{
		"label": "Burkina Faso",
		"code": "BF"
	},
	{
		"label": "Bulgarien",
		"code": "BG"
	},
	{
		"label": "Bahrain",
		"code": "BH"
	},
	{
		"label": "Burundi",
		"code": "BI"
	},
	{
		"label": "Benin",
		"code": "BJ"
	},
	{
		"label": "Saint-Barthélemy",
		"code": "BL"
	},
	{
		"label": "Bermuda",
		"code": "BM"
	},
	{
		"label": "Brunei",
		"code": "BN"
	},
	{
		"label": "Bolivia",
		"code": "BO"
	},
	{
		"label": "Brasilien",
		"code": "BR"
	},
	{
		"label": "Bahamas",
		"code": "BS"
	},
	{
		"label": "Bhutan",
		"code": "BT"
	},
	{
		"label": "Bouvetön",
		"code": "BV"
	},
	{
		"label": "Botswana",
		"code": "BW"
	},
	{
		"label": "Vitryssland",
		"code": "BY"
	},
	{
		"label": "Belize",
		"code": "BZ"
	},
	{
		"label": "Kanada",
		"code": "CA"
	},
	{
		"label": "Kokosöarna",
		"code": "CC"
	},
	{
		"label": "Demokratiska republiken Kongo",
		"code": "CD"
	},
	{
		"label": "Centralafrikanska republiken",
		"code": "CF"
	},
	{
		"label": "Kongo-Brazzaville",
		"code": "CG"
	},
	{
		"label": "Schweiz",
		"code": "CH"
	},
	{
		"label": "Elfenbenskusten",
		"code": "CI"
	},
	{
		"label": "Cooköarna",
		"code": "CK"
	},
	{
		"label": "Chile",
		"code": "CL"
	},
	{
		"label": "Kamerun",
		"code": "CM"
	},
	{
		"label": "Kina",
		"code": "CN"
	},
	{
		"label": "Colombia",
		"code": "CO"
	},
	{
		"label": "Costa Rica",
		"code": "CR"
	},
	{
		"label": "Kuba",
		"code": "CU"
	},
	{
		"label": "Kap Verde",
		"code": "CV"
	},
	{
		"label": "Julön",
		"code": "CX"
	},
	{
		"label": "Cypern",
		"code": "CY"
	},
	{
		"label": "Tjeckien",
		"code": "CZ"
	},
	{
		"label": "Tyskland",
		"code": "DE"
	},
	{
		"label": "Djibouti",
		"code": "DJ"
	},
	{
		"label": "Danmark",
		"code": "DK"
	},
	{
		"label": "Dominica",
		"code": "DM"
	},
	{
		"label": "Dominikanska republiken",
		"code": "DO"
	},
	{
		"label": "Algeriet",
		"code": "DZ"
	},
	{
		"label": "Ecuador",
		"code": "EC"
	},
	{
		"label": "Estland",
		"code": "EE"
	},
	{
		"label": "Egypten",
		"code": "EG"
	},
	{
		"label": "Västsahara",
		"code": "EH"
	},
	{
		"label": "Eritrea",
		"code": "ER"
	},
	{
		"label": "Spanien",
		"code": "ES"
	},
	{
		"label": "Etiopien",
		"code": "ET"
	},
	{
		"label": "Finland",
		"code": "FI"
	},
	{
		"label": "Fiji",
		"code": "FJ"
	},
	{
		"label": "Falklandsöarna",
		"code": "FK"
	},
	{
		"label": "Mikronesiska federationen",
		"code": "FM"
	},
	{
		"label": "Färöarna",
		"code": "FO"
	},
	{
		"label": "Frankrike",
		"code": "FR"
	},
	{
		"label": "France métropolitaine (Frankrike, europeiska delen)",
		"code": "FX"
	},
	{
		"label": "Gabon",
		"code": "GA"
	},
	{
		"label": "Storbritannien",
		"code": "GB"
	},
	{
		"label": "Grenada",
		"code": "GD"
	},
	{
		"label": "Georgien",
		"code": "GE"
	},
	{
		"label": "Franska Guyana",
		"code": "GF"
	},
	{
		"label": "Guernsey",
		"code": "GG"
	},
	{
		"label": "Ghana",
		"code": "GH"
	},
	{
		"label": "Gibraltar",
		"code": "GI"
	},
	{
		"label": "Grönland",
		"code": "GL"
	},
	{
		"label": "Gambia",
		"code": "GM"
	},
	{
		"label": "Guinea",
		"code": "GN"
	},
	{
		"label": "Guadeloupe",
		"code": "GP"
	},
	{
		"label": "Ekvatorialguinea",
		"code": "GQ"
	},
	{
		"label": "Grekland",
		"code": "GR"
	},
	{
		"label": "Guatemala",
		"code": "GT"
	},
	{
		"label": "Guam",
		"code": "GU"
	},
	{
		"label": "Guinea Bissau",
		"code": "GW"
	},
	{
		"label": "Guyana",
		"code": "GY"
	},
	{
		"label": "Hongkong",
		"code": "HK"
	},
	{
		"label": "Heard- och McDonaldöarna",
		"code": "HM"
	},
	{
		"label": "Honduras",
		"code": "HN"
	},
	{
		"label": "Kroatien",
		"code": "HR"
	},
	{
		"label": "Haiti",
		"code": "HT"
	},
	{
		"label": "Ungern",
		"code": "HU"
	},
	{
		"label": "Indonesien",
		"code": "ID"
	},
	{
		"label": "Irland",
		"code": "IE"
	},
	{
		"label": "Israel",
		"code": "IL"
	},
	{
		"label": "Isle of Man",
		"code": "IM"
	},
	{
		"label": "Indien",
		"code": "IN"
	},
	{
		"label": "Brittiska territoriet i Indiska Oceanen",
		"code": "IO"
	},
	{
		"label": "Irak",
		"code": "IQ"
	},
	{
		"label": "Iran",
		"code": "IR"
	},
	{
		"label": "Island",
		"code": "IS"
	},
	{
		"label": "Italien",
		"code": "IT"
	},
	{
		"label": "Jersey",
		"code": "JE"
	},
	{
		"label": "Jamaica",
		"code": "JM"
	},
	{
		"label": "Jordanien",
		"code": "JO"
	},
	{
		"label": "Japan",
		"code": "JP"
	},
	{
		"label": "Kenya",
		"code": "KE"
	},
	{
		"label": "Kirgizistan",
		"code": "KG"
	},
	{
		"label": "Kambodja",
		"code": "KH"
	},
	{
		"label": "Kiribati",
		"code": "KI"
	},
	{
		"label": "Komorerna",
		"code": "KM"
	},
	{
		"label": "Saint Kitts och Nevis",
		"code": "KN"
	},
	{
		"label": "Nordkorea",
		"code": "KP"
	},
	{
		"label": "Sydkorea",
		"code": "KR"
	},
	{
		"label": "Kuwait",
		"code": "KW"
	},
	{
		"label": "Caymanöarna",
		"code": "KY"
	},
	{
		"label": "Kazakstan",
		"code": "KZ"
	},
	{
		"label": "Laos",
		"code": "LA"
	},
	{
		"label": "Libanon",
		"code": "LB"
	},
	{
		"label": "Saint Lucia",
		"code": "LC"
	},
	{
		"label": "Liechtenstein",
		"code": "LI"
	},
	{
		"label": "Sri Lanka",
		"code": "LK"
	},
	{
		"label": "Liberia",
		"code": "LR"
	},
	{
		"label": "Lesotho",
		"code": "LS"
	},
	{
		"label": "Litauen",
		"code": "LT"
	},
	{
		"label": "Luxemburg",
		"code": "LU"
	},
	{
		"label": "Lettland",
		"code": "LV"
	},
	{
		"label": "Libyen",
		"code": "LY"
	},
	{
		"label": "Marocko",
		"code": "MA"
	},
	{
		"label": "Monaco",
		"code": "MC"
	},
	{
		"label": "Moldavien",
		"code": "MD"
	},
	{
		"label": "Montenegro",
		"code": "ME"
	},
	{
		"label": "Madagaskar",
		"code": "MG"
	},
	{
		"label": "Marshallöarna",
		"code": "MH"
	},
	{
		"label": "Makedonien",
		"code": "MK"
	},
	{
		"label": "Mali",
		"code": "ML"
	},
	{
		"label": "Burma",
		"code": "MM"
	},
	{
		"label": "Mongoliet",
		"code": "MN"
	},
	{
		"label": "Macau",
		"code": "MO"
	},
	{
		"label": "Nordmarianerna",
		"code": "MP"
	},
	{
		"label": "Martinique",
		"code": "MQ"
	},
	{
		"label": "Mauretanien",
		"code": "MR"
	},
	{
		"label": "Montserrat",
		"code": "MS"
	},
	{
		"label": "Malta",
		"code": "MT"
	},
	{
		"label": "Mauritius",
		"code": "MU"
	},
	{
		"label": "Maldiverna",
		"code": "MV"
	},
	{
		"label": "Malawi",
		"code": "MW"
	},
	{
		"label": "Mexiko",
		"code": "MX"
	},
	{
		"label": "Malaysia",
		"code": "MY"
	},
	{
		"label": "Moçambique",
		"code": "MZ"
	},
	{
		"label": "Namibia",
		"code": "NA"
	},
	{
		"label": "Nya Kaledonien",
		"code": "NC"
	},
	{
		"label": "Niger",
		"code": "NE"
	},
	{
		"label": "Norfolkön",
		"code": "NF"
	},
	{
		"label": "Nigeria",
		"code": "NG"
	},
	{
		"label": "Nicaragua",
		"code": "NI"
	},
	{
		"label": "Nederländerna",
		"code": "NL"
	},
	{
		"label": "Norge",
		"code": "NO"
	},
	{
		"label": "Nepal",
		"code": "NP"
	},
	{
		"label": "Nauru",
		"code": "NR"
	},
	{
		"label": "Niue",
		"code": "NU"
	},
	{
		"label": "Nya Zeeland",
		"code": "NZ"
	},
	{
		"label": "Oman",
		"code": "OM"
	},
	{
		"label": "Panama",
		"code": "PA"
	},
	{
		"label": "Peru",
		"code": "PE"
	},
	{
		"label": "Franska Polynesien",
		"code": "PF"
	},
	{
		"label": "Papua Nya Guinea",
		"code": "PG"
	},
	{
		"label": "Filippinerna",
		"code": "PH"
	},
	{
		"label": "Pakistan",
		"code": "PK"
	},
	{
		"label": "Polen",
		"code": "PL"
	},
	{
		"label": "Saint-Pierre och Miquelon",
		"code": "PM"
	},
	{
		"label": "Pitcairnöarna",
		"code": "PN"
	},
	{
		"label": "Puerto Rico",
		"code": "PR"
	},
	{
		"label": "Portugal",
		"code": "PT"
	},
	{
		"label": "Palau",
		"code": "PW"
	},
	{
		"label": "Paraguay",
		"code": "PY"
	},
	{
		"label": "Qatar",
		"code": "QA"
	},
	{
		"label": "Réunion",
		"code": "RE"
	},
	{
		"label": "Rumänien",
		"code": "RO"
	},
	{
		"label": "Serbien",
		"code": "RS"
	},
	{
		"label": "Ryssland",
		"code": "RU"
	},
	{
		"label": "Rwanda",
		"code": "RW"
	},
	{
		"label": "Saudiarabien",
		"code": "SA"
	},
	{
		"label": "Salomonöarna",
		"code": "SB"
	},
	{
		"label": "Seychellerna",
		"code": "SC"
	},
	{
		"label": "Sudan",
		"code": "SD"
	},
	{
		"label": "Sverige",
		"code": "SE"
	},
	{
		"label": "Singapore",
		"code": "SG"
	},
	{
		"label": "Sankta Helena",
		"code": "SH"
	},
	{
		"label": "Slovenien",
		"code": "SI"
	},
	{
		"label": "Svalbard och Jan Mayen",
		"code": "SJ"
	},
	{
		"label": "Slovakien",
		"code": "SK"
	},
	{
		"label": "Sierra Leone",
		"code": "SL"
	},
	{
		"label": "San Marino",
		"code": "SM"
	},
	{
		"label": "Senegal",
		"code": "SN"
	},
	{
		"label": "Somalia",
		"code": "SO"
	},
	{
		"label": "Surinam",
		"code": "SR"
	},
	{
		"label": "São Tomé och Príncipe",
		"code": "ST"
	},
	{
		"label": "El Salvador",
		"code": "SV"
	},
	{
		"label": "Syrien",
		"code": "SY"
	},
	{
		"label": "Swaziland",
		"code": "SZ"
	},
	{
		"label": "Turks- och Caicosöarna",
		"code": "TC"
	},
	{
		"label": "Tchad",
		"code": "TD"
	},
	{
		"label": "Franska södra territorierna",
		"code": "TF"
	},
	{
		"label": "Togo",
		"code": "TG"
	},
	{
		"label": "Thailand",
		"code": "TH"
	},
	{
		"label": "Tadzjikistan",
		"code": "TJ"
	},
	{
		"label": "Tokelauöarna",
		"code": "TK"
	},
	{
		"label": "Östtimor a.k.a. Timor-Leste",
		"code": "TL"
	},
	{
		"label": "Turkmenistan",
		"code": "TM"
	},
	{
		"label": "Tunisien",
		"code": "TN"
	},
	{
		"label": "Tonga",
		"code": "TO"
	},
	{
		"label": "Östtimor",
		"code": "TP"
	},
	{
		"label": "Turkiet",
		"code": "TR"
	},
	{
		"label": "Trinidad och Tobago",
		"code": "TT"
	},
	{
		"label": "Tuvalu",
		"code": "TV"
	},
	{
		"label": "Taiwan",
		"code": "TW"
	},
	{
		"label": "Tanzania",
		"code": "TZ"
	},
	{
		"label": "Ukraina",
		"code": "UA"
	},
	{
		"label": "Uganda",
		"code": "UG"
	},
	{
		"label": "USA:s yttre öar",
		"code": "UM"
	},
	{
		"label": "USA",
		"code": "US"
	},
	{
		"label": "Uruguay",
		"code": "UY"
	},
	{
		"label": "Uzbekistan",
		"code": "UZ"
	},
	{
		"label": "Vatikanstaten",
		"code": "VA"
	},
	{
		"label": "Saint Vincent och Grenadinerna",
		"code": "VC"
	},
	{
		"label": "Venezuela",
		"code": "VE"
	},
	{
		"label": "Brittiska Jungfruöarna",
		"code": "VG"
	},
	{
		"label": "Amerikanska Jungfruöarna",
		"code": "VI"
	},
	{
		"label": "Vietnam",
		"code": "VN"
	},
	{
		"label": "Vanuatu",
		"code": "VU"
	},
	{
		"label": "Wallis- och Futunaöarna",
		"code": "WF"
	},
	{
		"label": "Samoa",
		"code": "WS"
	},
	{
		"label": "Jemen",
		"code": "YE"
	},
	{
		"label": "Mayotte",
		"code": "YT"
	},
	{
		"label": "Sydafrika",
		"code": "ZA"
	},
	{
		"label": "Zambia",
		"code": "ZM"
	},
	{
		"label": "Zimbabwe",
		"code": "ZW"
	}
];


// WEBPACK FOOTER //
// ./src/helpers/countries.js